/* Theme-only review presentation safeguards. No review data is changed. */
(() => {
  'use strict';

  const entityPattern = /(?:&amp;)?(?:#(?:x27|39)|apos|quot);/i;

  const decodeEntities = (value) => {
    let decoded = value;
    for (let index = 0; index < 2 && entityPattern.test(decoded); index += 1) {
      const decoder = document.createElement('textarea');
      decoder.innerHTML = decoded;
      decoded = decoder.value;
    }
    return decoded;
  };

  const normaliseVisibleText = (widget) => {
    const walker = document.createTreeWalker(widget, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      if (entityPattern.test(node.nodeValue)) node.nodeValue = decodeEntities(node.nodeValue);
    });
  };

  const getReviewCount = (widget) => {
    const countNode = widget.querySelector('[data-imr-count]');
    const source = countNode?.textContent || widget.textContent || '';
    const match = source.match(/(?:^|\D)(\d+)\s+recension(?:e|i)\b/i);
    return match ? Number(match[1]) : null;
  };

  const matchingCarousel = (widget) => {
    const productId = widget.dataset.productId;
    if (!productId) return null;
    return [...document.querySelectorAll('.immershop-review-carousel immershop-review-carousel')]
      .find((carousel) => carousel.dataset.productId === productId)
      ?.closest('.immershop-review-carousel');
  };

  const renderEmptyState = (widget, count) => {
    const isEmpty = count === 0;
    widget.classList.toggle('imr-theme-empty', isEmpty);
    matchingCarousel(widget)?.classList.toggle('imr-theme-empty-carousel', isEmpty);

    const existing = widget.querySelector('[data-imr-theme-empty-state]');
    if (!isEmpty) {
      existing?.remove();
      return;
    }
    if (existing) return;

    const state = document.createElement('div');
    state.className = 'imr-theme-empty-state';
    state.dataset.imrThemeEmptyState = '';

    const invitation = document.createElement('p');
    invitation.textContent = "Sii il primo a raccontare com'è andata.";
    state.append(invitation);

    const writeReview = widget.querySelector('[data-imr-open-form]');
    if (writeReview) state.append(writeReview);
    widget.append(state);
  };

  const sync = (widget) => {
    normaliseVisibleText(widget);
    renderEmptyState(widget, getReviewCount(widget));
  };

  const bindFormTriggerFallback = (widget) => {
    if (widget.dataset.imrThemeFormFallback === 'true') return;
    widget.dataset.imrThemeFormFallback = 'true';
    widget.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-imr-open-form]');
      if (!trigger) return;
      const form = widget.querySelector('[data-imr-form]');
      if (!form) return;
      form.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(() => form.querySelector('input, textarea, button')?.focus());
    });
  };

  const observe = (widget) => {
    bindFormTriggerFallback(widget);
    let scheduled = false;
    const queueSync = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        sync(widget);
      });
    };
    new MutationObserver(queueSync).observe(widget, { childList: true, subtree: true, characterData: true });
    queueSync();
  };

  const start = () => document.querySelectorAll('immershop-reviews').forEach(observe);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
